import React from 'react';
import '../../../../../../../../../../styles.css';
import { timeStamp } from '../../../../../../../../../../utils/helper';

function Snippet({ message, showTimeStamp }) {
  return (
    <div>
      <div className="rcw-snippet">
        <h5 className="rcw-snippet-title">{message.title}</h5>
        <div className="rcw-snippet-details">
          <a href={message.link} target={message.target} className="rcw-link">
            {message.link}
          </a>
        </div>
      </div>
      {showTimeStamp && <span className="rcw-timestamp">{timeStamp(message.timestamp)}</span>}
    </div>
  );
}

export default Snippet;
